import React from 'react'
import moment from 'moment'

// components
import {
  CRow,
  CFormLabel
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'
import FormPassengers from 'src/components/form/general-input-form/FormPassenger'

// helpers
import { convertMoney } from '../../../helpers/format-number'
import { capitalizeFirstLetter } from '../../../helpers/text-format'

const AppDetails = ({
  expenseDetails,
  handleViewFile
}) => {
  let files = []
  if (expenseDetails?.attachment_url) {
    files = [{
      attachment_url: expenseDetails?.attachment_url,
      attachment_original_name: expenseDetails?.attachment_original_name
    }]
  }

  return (
    <>
      <CRow className='mb-3'>
        <AppTextColumnDetails
          colSize="4"
          className='mb-3'
          title="Expense name"
          subtitle={expenseDetails?.name}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="Expense value"
          subtitle={`IDR ${convertMoney(expenseDetails?.value)}`}
        />
        <AppTextColumnDetails
          colSize="5"
          className='mb-3'
          title="Expense Description"
          subtitle={expenseDetails?.description}
        />
      </CRow>
      <CRow className='mb-3'>
        <AppTextColumnDetails
          colSize="4"
          className='mb-3'
          title="Expense date"
          subtitle={moment(expenseDetails?.date).format('DD/MM/YYYY')}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="Expense repeat start date"
          subtitle={expenseDetails?.repeat_start_date ? moment(expenseDetails?.repeat_start_date).format('DD/MM/YYYY') : 'No repeat date'}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="Expense repeat end date"
          subtitle={expenseDetails?.repeat_end_date ? moment(expenseDetails?.repeat_end_date).format('DD/MM/YYYY') : 'No repeat date'}
        />
      </CRow>
      <CRow className='mb-3'>
        <AppTextColumnDetails
          colSize="4"
          className='mb-3'
          title="Expense repeat interval"
          subtitle={expenseDetails?.repeat_interval ? capitalizeFirstLetter(expenseDetails?.repeat_interval) : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="Expense repeat forever"
          subtitle={expenseDetails?.repeat_forever ? 'Yes' : 'No'}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="Project name"
          subtitle={expenseDetails?.project ? expenseDetails?.project?.name : '-'}
        />
        {
          files?.length > 0 && (
            <CRow className='mt-3'>
              <CFormLabel>
                Document attachment
              </CFormLabel>
              <FormFileThumbnail 
                colSize="4"
                files={files}
                isDetailPage={true}
                handleViewFile={handleViewFile}
              />
            </CRow>
          )
        }
      </CRow>
      <CRow>
          <AppTextColumnDetails
            colSize="4"
            title="Expense category"
            className='mb-3'
            subtitle={expenseDetails?.category?.name ? expenseDetails?.category?.name : '-'}
          />
          {
            expenseDetails?.category?.name == 'Flight' && (
              <>
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Reservation number"
                  subtitle={expenseDetails?.flight?.reservation_number ? expenseDetails?.flight?.reservation_number : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Airplane name"
                  subtitle={expenseDetails?.flight?.airplane_name ? expenseDetails?.flight?.airplane_name : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title="Flight details"
                  subtitle={expenseDetails?.flight?.flight_details ? expenseDetails?.flight?.flight_details : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Flight type"
                  subtitle={expenseDetails?.flight?.flight_type ? expenseDetails?.flight?.flight_type : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Booking through"
                  subtitle={expenseDetails?.flight?.booking_through ? expenseDetails?.flight?.booking_through == 'Others' ? expenseDetails?.flight?.other_booking_input : expenseDetails?.flight?.booking_through : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title={expenseDetails?.flight?.reservation_date_2 ? 'Flight departure date' : 'Flight date'}
                  subtitle={expenseDetails?.flight?.reservation_date_1 ? moment(expenseDetails?.flight?.reservation_date_1).format('DD/MM/YYYY') : '-'}
                />
                {
                  expenseDetails?.flight?.reservation_date_2 && (
                    <AppTextColumnDetails
                      colSize="3"
                      className='mb-3'
                      title="Flight return date"
                      subtitle={expenseDetails?.flight?.reservation_date_2 ? moment(expenseDetails?.flight?.reservation_date_2).format('DD/MM/YYYY') : '-'}
                    />
                  )
                }
              </>
            )
          }
          {
            expenseDetails?.category?.name == 'Accomodation' && (
              <>
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Reservation number"
                  subtitle={expenseDetails?.accomodation?.reservation_number ? expenseDetails?.accomodation?.reservation_number : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Accomodation name"
                  subtitle={expenseDetails?.accomodation?.accomodation_name ? expenseDetails?.accomodation?.accomodation_name : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title="Accomodation details"
                  subtitle={expenseDetails?.accomodation?.accomodation_details ? expenseDetails?.accomodation?.accomodation_details : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Accomodation address"
                  subtitle={expenseDetails?.accomodation?.accomodation_address ? expenseDetails?.accomodation?.accomodation_address : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Accomodation province"
                  subtitle={expenseDetails?.accomodation?.province?.label ? expenseDetails?.accomodation?.province?.label : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title="Accomodation city"
                  subtitle={expenseDetails?.accomodation?.city?.label ? expenseDetails?.accomodation?.city?.label : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Booking through"
                  subtitle={expenseDetails?.accomodation?.booking_through ? expenseDetails?.accomodation?.booking_through == 'Others' ? expenseDetails?.accomodation?.other_booking_input : expenseDetails?.accomodation?.booking_through : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title={expenseDetails?.accomodation?.reservation_date_2 ? 'Reservation start' : 'Reservation date'}
                  subtitle={expenseDetails?.accomodation?.reservation_date_1 ? moment(expenseDetails?.accomodation?.reservation_date_1).format('DD/MM/YYYY') : '-'}
                />
                {
                  expenseDetails?.accomodation?.reservation_date_2 && (
                    <AppTextColumnDetails
                      colSize="4"
                      className='mb-3'
                      title="Reservation end"
                      subtitle={expenseDetails?.accomodation?.reservation_date_2 ? moment(expenseDetails?.accomodation?.reservation_date_2).format('DD/MM/YYYY') : '-'}
                    />
                  )
                }
              </>
            )
          }
          {
            expenseDetails?.category?.name == 'Train' && (
              <>
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Reservation number"
                  subtitle={expenseDetails?.train?.reservation_number ? expenseDetails?.train?.reservation_number : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Train name"
                  subtitle={expenseDetails?.train?.train_name ? expenseDetails?.train?.train_name : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title="Train details"
                  subtitle={expenseDetails?.train?.train_details ? expenseDetails?.train?.train_details : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Train type"
                  subtitle={expenseDetails?.train?.train_type ? expenseDetails?.train?.train_type : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Booking through"
                  subtitle={expenseDetails?.train?.booking_through ? expenseDetails?.train?.booking_through == 'Others' ? expenseDetails?.train?.other_booking_input : expenseDetails?.train?.booking_through : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title={expenseDetails?.train?.reservation_date_2 ? 'Train departure date' : 'Train date'}
                  subtitle={expenseDetails?.train?.reservation_date_1 ? moment(expenseDetails?.train?.reservation_date_1).format('DD/MM/YYYY') : '-'}
                />
                {
                  expenseDetails?.train?.reservation_date_2 && (
                    <AppTextColumnDetails
                      colSize="3"
                      className='mb-3'
                      title="Train return date"
                      subtitle={expenseDetails?.train?.reservation_date_2 ? moment(expenseDetails?.train?.reservation_date_2).format('DD/MM/YYYY') : '-'}
                    />
                  )
                }
              </>
            )
          }
          {
            expenseDetails?.category?.name == 'Car rental' && (
              <>
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Rental company"
                  subtitle={expenseDetails?.car_rental?.rental_company ? expenseDetails?.car_rental?.rental_company : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Description"
                  subtitle={expenseDetails?.car_rental?.description ? expenseDetails?.car_rental?.description : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title="Car type"
                  subtitle={expenseDetails?.car_rental?.car_type ? expenseDetails?.car_rental?.car_type : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title={expenseDetails?.car_rental?.booking_end ? 'Booking start' : 'Booking period'}
                  subtitle={expenseDetails?.car_rental?.booking_start ? moment(expenseDetails?.car_rental?.booking_start).format('DD/MM/YYYY') : '-'}
                />
                {
                  expenseDetails?.car_rental?.booking_end && (
                    <AppTextColumnDetails
                      colSize="3"
                      className='mb-3'
                      title="Booking end"
                      subtitle={expenseDetails?.car_rental?.booking_end ? moment(expenseDetails?.car_rental?.booking_end).format('DD/MM/YYYY') : '-'}
                    />
                  )
                }
              </>
            )
          }
          {
            expenseDetails?.category?.name == 'Pettycash & Operational' && (
              <>
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Date time"
                  subtitle={expenseDetails?.pettycash_operational?.datetime ? moment(expenseDetails?.pettycash_operational?.datetime).format('DD/MM/YYYY') : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Description"
                  subtitle={expenseDetails?.pettycash_operational?.description ? expenseDetails?.pettycash_operational?.description : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title="Tags"
                  subtitle={expenseDetails?.pettycash_operational?.pettycash_tags?.length > 0 ? expenseDetails?.pettycash_operational?.pettycash_tags?.map((val) => val?.tags?.name)?.join(', ') : '-'}
                />
              </>
            )
          }
          {
            expenseDetails?.category?.name == 'Meals' && (
              <>
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Restaurant"
                  subtitle={expenseDetails?.meal?.restaurant_name ? expenseDetails?.meal?.restaurant_name : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Date time"
                  subtitle={expenseDetails?.meal?.datetime ? moment(expenseDetails?.meal?.datetime).format('DD/MM/YYYY') : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title="Description"
                  subtitle={expenseDetails?.meal?.description ? expenseDetails?.meal?.description : '-'}
                />
              </>
            )
          }
          {
            expenseDetails?.category?.name == 'Fuel' && (
              <>
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Company"
                  subtitle={expenseDetails?.fuel?.company_name ? expenseDetails?.fuel?.company_name == 'Others' ? expenseDetails?.fuel?.other_company_input : expenseDetails?.fuel?.company_name : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Date time"
                  subtitle={expenseDetails?.fuel?.datetime ? moment(expenseDetails?.fuel?.datetime).format('DD/MM/YYYY') : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title="Description"
                  subtitle={expenseDetails?.fuel?.description ? expenseDetails?.fuel?.description : '-'}
                />
              </>
            )
          }
          {
            expenseDetails?.category?.name == 'E-toll money' && (
              <>
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Date time"
                  subtitle={expenseDetails?.etoll_money?.datetime ? moment(expenseDetails?.etoll_money?.datetime).format('DD/MM/YYYY') : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Description"
                  subtitle={expenseDetails?.etoll_money?.description ? expenseDetails?.etoll_money?.description : '-'}
                />
              </>
            )
          }
          {
            expenseDetails?.category?.name == 'Transportation' && (
              <>
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Transportation"
                  subtitle={expenseDetails?.transportation?.transportation_category ? expenseDetails?.transportation?.transportation_category == 'Others' ? expenseDetails?.transportation?.other_transportation_input : expenseDetails?.transportation?.transportation_category : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Date time"
                  subtitle={expenseDetails?.transportation?.datetime ? moment(expenseDetails?.transportation?.datetime).format('DD/MM/YYYY') : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title="Description"
                  subtitle={expenseDetails?.transportation?.description ? expenseDetails?.transportation?.description : '-'}
                />
              </>
            )
          }
          {
            expenseDetails?.category?.name == 'Office supply / stationery' && (
              <>
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Company"
                  subtitle={expenseDetails?.office_supply?.company ? expenseDetails?.office_supply?.company : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Date time"
                  subtitle={expenseDetails?.office_supply?.datetime ? moment(expenseDetails?.office_supply?.datetime).format('DD/MM/YYYY') : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title="Description"
                  subtitle={expenseDetails?.office_supply?.description ? expenseDetails?.office_supply?.description : '-'}
                />
              </>
            )
          }
          {
            expenseDetails?.category?.name == 'Printing' && (
              <>
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Company"
                  subtitle={expenseDetails?.printing?.company ? expenseDetails?.printing?.company : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Date time"
                  subtitle={expenseDetails?.printing?.datetime ? moment(expenseDetails?.printing?.datetime).format('DD/MM/YYYY') : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title="Description"
                  subtitle={expenseDetails?.printing?.description ? expenseDetails?.printing?.description : '-'}
                />
              </>
            )
          }
          {
            expenseDetails?.category?.name == 'Other reimbursement' && (
              <>
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Reimbursement for"
                  subtitle={expenseDetails?.other_reimbursement?.reimbursement_for ? expenseDetails?.other_reimbursement?.reimbursement_for : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Company"
                  subtitle={expenseDetails?.other_reimbursement?.company ? expenseDetails?.other_reimbursement?.company : '-'}
                />
                <AppTextColumnDetails
                  colSize="4"
                  className='mb-3'
                  title="Date time"
                  subtitle={expenseDetails?.other_reimbursement?.datetime ? moment(expenseDetails?.other_reimbursement?.datetime).format('DD/MM/YYYY') : '-'}
                />
                <AppTextColumnDetails
                  colSize="3"
                  className='mb-3'
                  title="Description"
                  subtitle={expenseDetails?.other_reimbursement?.description ? expenseDetails?.other_reimbursement?.description : '-'}
                />
              </>
            )
          }
          <AppTextColumnDetails
            colSize="3"
            className='mb-3'
            title="Expense Notes"
            subtitle={expenseDetails?.notes ? expenseDetails?.notes : '-'}
          />
      </CRow>
      {
        expenseDetails?.category && (
          <CRow>
            {
              expenseDetails?.category?.name == 'Flight' && (
                <FormPassengers 
                  passengers={expenseDetails?.flight?.passengers}
                  type={'flight'}
                  isDetail={true}
                />
              )
            }
            {
              expenseDetails?.category?.name == 'Train' && (
                <FormPassengers 
                  passengers={expenseDetails?.train?.passengers}
                  type={'train'}
                  isDetail={true}
                />
              )
            }
            {
              expenseDetails?.category?.name == 'Accomodation' && (
                <FormPassengers 
                  passengers={expenseDetails?.accomodation?.guests}
                  type={'accomodation'}
                  isDetail={true}
                />
              )
            }
          </CRow>
        )
      }
    </>
  )
}

export default AppDetails
